import { tokens } from "../../tokens";

/**
 * MuiInputBase – use theme.palette for placeholder and disabled.
 */
export const MuiInputBaseOverrides = {
  styleOverrides: ({ theme }) => ({
    root: {
      fontFamily: tokens.typography.fontFamily,
      "&.Mui-disabled": {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
      },
    },
    input: {
      "&::placeholder": {
        color: theme.palette.text.secondary,
        opacity: 0.7,
      },
    },
  }),
};
